import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { PROFILE_CHARACTER_TYPE_IMAGE_LIST } from 'src/app/customers/marketplace/marketplace.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { HtmlToPngService } from 'src/app/shareModule/services/html-to-png.service';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import {
  trigger,
  state,
  style,
  animate,
  transition,
} from '@angular/animations';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { select, Store } from '@ngrx/store';
import { loadUser, selectUser } from 'src/app/shareModule/states/user-details';
import { filter, take } from 'rxjs';
import { User } from 'src/app/shareModule/models/user.model';
import { AppState } from 'src/app/shareModule/states/app.state';
@Component({
  selector: 'app-avatar-profile',
  templateUrl: './avatar-profile.component.html',
  styleUrls: ['./avatar-profile.component.scss'],
  animations: [
    trigger('toggleAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms ease-in', style({ opacity: 1 })),
      ]),
      transition(':leave', [animate('0s ease-out', style({ opacity: 0 }))]),
    ]),
  ],
})
export class AvatarProfileComponent implements OnInit {
  public showOption: boolean = false;
  ballPosition = { top: '0px', left: '0px' };

  public charName: string = '';
  public imgUrl = environment.ImageUrl;
  public imgAssetsUrl = '../../../../../assets/images/';
  public primaryImage: string = '';
  public primaryImageList: any = [];
  public subCategoryList: Array<any> = [];
  public profileCharacterTypeImageList: any = PROFILE_CHARACTER_TYPE_IMAGE_LIST;
  public availableItemList: {} = {};
  public primaryImageZIndex = {};
  public modelRef: any = null;
  public showBaseImage: boolean = false;

  /**
   * Constructor
   */
  constructor(
    private sharedService: SharedService,
    public commonService: CommonService,
    private toastr: ToastrService,
    private auth: AuthServiceService,
    private modalService: NgbModal,
    private htmlToPngService: HtmlToPngService,
    private customerService: CustomerService,
    private store: Store<AppState>,
  ) { }

  ngOnInit(): void {
    this._getAvailableCharacterListForMember();
    for (let i of this.profileCharacterTypeImageList) {
      this.primaryImageZIndex[i.category] = i.zIndex;
    }
  }

  public selectedType: string = '';
  openEquipModel(type: string) {
    this.showOption = true;
    this.selectedType = type;
    this.subCategoryList = this.availableItemList[type];
    this.scrollTop();
  }
  public equipItem(item: any) {
    // Validation
    let itemPreset: boolean = false;
    let list = this.primaryImageList;
    for (let i in list) {
      if (list[i].id == item.id) {
        itemPreset = true;
      }
      if (list[i].profileCharacter.category == item.profileCharacter.category) {
        list[i] = item;
        itemPreset = true;
      }
    }
    !itemPreset ? list.push(item) : '';
    this.primaryImageList = [...list];
    // Validation
    this.selectedType = '';
    this.showOption = false;
    this.scrollTop();
    this.updateProfile({
      profileCharacterImage: JSON.stringify(
        this.commonService.uniqueById(this.primaryImageList)
      ),
    });
  }

  public unEquipItem(item: any) {
    // Validation
    let list = [];
    for (let i of this.primaryImageList) {
      if (i.profileCharacter.category != item.profileCharacter.category) {
        list.push(i);
      }
    }
    this.primaryImageList = [...list];
    // Validation

    this.updateProfile({
      profileCharacterImage: JSON.stringify(
        this.commonService.uniqueById(this.primaryImageList)
      ),
    });
    // this.resetAnimation()
  }
  scrollTop() {
    const element = document.getElementsByClassName('profilePopupMenu')[0];
    if (element) {
      const content = element.getElementsByClassName('content')[0];
      if (content) {
        content.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  }
  public back(): void {
    this.showOption = false;
    this.scrollTop();
  }

  public getProfileCharacterDetails(availableList: Array<any>) {
    this.store.pipe(select(selectUser)).pipe(filter(user => !!user), take(1)).subscribe((resp: User) => {
      const data = resp;
      this.charName = data.profileCharacterName;
      let currentProfileCharacter = [];

      try {
        currentProfileCharacter =
          JSON.parse(resp.profileCharacterImage) || [];
      } catch (e) { }

      for (let i of availableList) {
        if (currentProfileCharacter.includes(i.id)) {
          this.primaryImageList.push(i);
          this._updateBaseImage(
            i.profileCharacter.category,
            i.profileCharacter.image
          );
        }
      }
      if (
        this.primaryImageList.filter(
          (i) => i.profileCharacter.category == 'eyes'
        ).length == 0
      ) {
        this.showBaseImage = true;
      }

    });
  }

  private _updateBaseImage(category: string, image: string) {
    if (category == 'base') {
      this.primaryImage = 'url(' + this.imgUrl + image + ')';
    } else if (this.primaryImage && category == 'background') {
      this.primaryImage += ', url(' + this.imgUrl + image + ')';
    }
    this.profileCharacterTypeImageList = this.profileCharacterTypeImageList.map(
      (i) => {
        let output = i;
        if (category == i.category) {
          output['image'] = image;
        }
        return output;
      }
    );
  }

  public updateProfile(payload) {
    this.auth
      .updateProfileCharacterDetails(payload)
      .subscribe((resp: ApiResponse) => {
        if (resp.message) {
          this.toastr.success(resp.message);
          this.primaryImage =
            'url(../../../../../assets/images/profile-charactor/base-male.png' +
            ')';
          this.getProfileCharacterDetails([...this.primaryImageList]);
        }
        this.back();
      }, ({ error }) => {
        this.toastr.error(error.message);
      });
  }
  @ViewChild('elementToConvert') elementToConvert!: ElementRef;

  async saveAsPNG() {
    if (this.elementToConvert) {
      try {
        const blob = await this.htmlToPngService.convertToImage(
          this.elementToConvert.nativeElement
        );

        const formData = new FormData();
        formData.append('profileImage', blob, 'profile_picture.png');

        this.auth.updateProfileCharacterDetails(formData).subscribe(
          (response: ApiResponse) => {
            this.toastr.success(response.message);
            this.store.dispatch(loadUser({}));
          },
          (e) => {
            this.toastr.error('Failed to Save Avatar');
          }
        );
      } catch (error) {
        this.toastr.error('Failed to Save Avatar');
      }
    }
  }

  public adjustName(name) {
    if (name == 'cloth') {
      return 'armour';
    }

    return name;
  }

  private _getAvailableCharacterListForMember() {
    console.log("AVATAR 2")
    this.customerService.getCharacterListForMember().subscribe((resp: ApiResponse) => {
      if (resp.body && resp.body.length > 0) {
        for (let i of resp.body) {
          if (this.availableItemList[i?.profileCharacter?.category]) {
            this.availableItemList[i?.profileCharacter?.category].push(i);
          } else {
            this.availableItemList[i?.profileCharacter?.category] = [i];
          }
        }
      }
      this.getProfileCharacterDetails(resp.body);
    });
  }

  public getZIndex(type: string) {
    return this.primaryImageZIndex[type];
  }

  GoToMyTabs(index: any) {
    this.sharedService.triggerSelectMyTab(index);
  }
}
